import { Errors, Warnings, trackError, trackWarning } from "modules/monitoring";
import { isAdBlockEnabled } from "modules/systemCheck/utils/isAdBlockEnabled";
import { withTimeout } from "modules/systemCheck/utils/withTimeout";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import { selectAdBlockResult } from "../../redux/selectors";
import { setAdBlockResult } from "../../redux/systemCheckSlice";

export const AdBlockTest = () => {
  const dispatch = useAppDispatch();
  const adBlockResult = useSelector(selectAdBlockResult);
  const { isDirty, isLoading } = adBlockResult;

  useEffect(() => {
    if (isDirty === true && isLoading === false) {
      dispatch(
        setAdBlockResult({
          isDirty: false,
          isLoading: true,
          isSuccessful: null,
        }),
      );

      (async () => {
        try {
          const result = await withTimeout(isAdBlockEnabled);

          dispatch(
            setAdBlockResult({
              isDirty: false,
              isLoading: false,
              isSuccessful: !result,
            }),
          );

          if (result === true) {
            trackWarning(Warnings.GEARTEST_ADBLOCK_DETECTED);
          }
        } catch (error) {
          dispatch(
            setAdBlockResult({
              isDirty: false,
              isLoading: false,
              isSuccessful: true,
            }),
          );

          trackError(error, { label: Errors.ADBLOCK_DETECTION });
        }
      })();
    }
  });

  return null;
};
